"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualDataServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
class ManualDataService extends client_1.RWSService {
    createEmptyEntry() {
        return ManualDataService.emptyEntry;
    }
    validateEntry(entry) {
        const errors = [];
        if (!entry.input.trim()) {
            errors.push('Input field is required');
        }
        if (!entry.output.trim()) {
            errors.push('Output field is required');
        }
        if (entry.input.length > 4000) {
            errors.push('Input field is too long (max 4000 characters)');
        }
        if (entry.output.length > 4000) {
            errors.push('Output field is too long (max 4000 characters)');
        }
        return {
            isValid: errors.length === 0,
            errors
        };
    }
    addEntry(data, entry) {
        const newEntry = { ...entry, id: Date.now().toString() };
        return [...data, newEntry];
    }
    updateEntry(data, index, entry) {
        const updatedData = [...data];
        updatedData[index] = { ...entry };
        return updatedData;
    }
    removeEntry(data, index) {
        const updatedData = [...data];
        updatedData.splice(index, 1);
        return updatedData;
    }
    duplicateEntry(data, index) {
        const originalEntry = data[index];
        const duplicatedEntry = {
            ...originalEntry,
            id: Date.now().toString(),
            input: originalEntry.input + ' (Copy)',
            output: originalEntry.output
        };
        return [...data, duplicatedEntry];
    }
    reorderEntries(data, fromIndex, toIndex) {
        const updatedData = [...data];
        const [removed] = updatedData.splice(fromIndex, 1);
        updatedData.splice(toIndex, 0, removed);
        return updatedData;
    }
    findDuplicateEntries(data) {
        const duplicateIndices = [];
        const inputSet = new Set();
        data.forEach((item, index) => {
            if (inputSet.has(item.input.trim())) {
                duplicateIndices.push(index);
            }
            else {
                inputSet.add(item.input.trim());
            }
        });
        return duplicateIndices;
    }
    filterByCategory(data, category) {
        if (!category)
            return data;
        return data.filter(item => item.category === category);
    }
    searchEntries(data, query) {
        if (!query.trim())
            return data;
        const searchTerm = query.toLowerCase();
        return data.filter(item => item.input.toLowerCase().includes(searchTerm) ||
            item.output.toLowerCase().includes(searchTerm) ||
            (item.category && item.category.toLowerCase().includes(searchTerm)));
    }
    getCategories(data) {
        const categorySet = new Set();
        data.forEach(item => {
            if (item.category && item.category.trim()) {
                categorySet.add(item.category.trim());
            }
        });
        return Array.from(categorySet).sort();
    }
    bulkUpdateCategory(data, indices, newCategory) {
        const updatedData = [...data];
        indices.forEach(index => {
            if (index >= 0 && index < updatedData.length) {
                updatedData[index] = { ...updatedData[index], category: newCategory };
            }
        });
        return updatedData;
    }
    importFromTemplate(template) {
        const templates = {
            qa: [
                {
                    id: '1',
                    input: 'What is the capital of France?',
                    output: 'The capital of France is Paris.',
                    category: 'Geography'
                },
                {
                    id: '2',
                    input: 'How do I reset my password?',
                    output: 'To reset your password, click on the "Forgot Password" link on the login page and follow the instructions.',
                    category: 'Help'
                }
            ],
            conversation: [
                {
                    id: '1',
                    input: 'Hello, how are you today?',
                    output: 'Hello! I\'m doing well, thank you for asking. How can I help you today?',
                    category: 'Greeting'
                },
                {
                    id: '2',
                    input: 'Thank you for your help!',
                    output: 'You\'re very welcome! I\'m glad I could help. If you have any other questions, feel free to ask.',
                    category: 'Gratitude'
                }
            ],
            instruction: [
                {
                    id: '1',
                    input: 'Summarize the main points of this article about climate change.',
                    output: 'I\'d be happy to help summarize the article about climate change. Could you please provide the article text so I can identify and summarize its main points?',
                    category: 'Instruction'
                },
                {
                    id: '2',
                    input: 'Write a professional email to schedule a meeting.',
                    output: 'Here\'s a professional email template for scheduling a meeting:\n\nSubject: Meeting Request - [Topic]\n\nDear [Name],\n\nI hope this email finds you well. I would like to schedule a meeting to discuss [topic/purpose]. \n\nWould you be available for a [duration] meeting sometime next week? I\'m flexible with timing and can accommodate your schedule.\n\nPlease let me know what works best for you.\n\nBest regards,\n[Your name]',
                    category: 'Writing'
                }
            ]
        };
        return templates[template] || [];
    }
}
exports.ManualDataServiceInstance = ManualDataService;
ManualDataService.emptyEntry = {
    id: Date.now().toString(),
    input: '',
    output: '',
    category: '',
    metadata: {}
};
exports.default = ManualDataService.getSingleton();
